import React from "react";
import CardSection from "../../../components/ui/CardSection";
import SummaryRow from "../../../components/ui/SummaryRow";
import { ISale } from "../../../classes/interfaces";
import { UpdatedAt, CancellationReason } from "./OrderSummarySection.styles";
import { formatBRL } from "../../../helpers/currency.helper";

interface OrderSummarySectionProps {
  sale: ISale;
}

function padLeadingZeros(num: number, size: number) {
  var s = num + "";
  while (s.length < size) s = "0" + s;
  return s;
}

// Exported so StatusTimeline.tsx can reuse it for each status entry's timestamp
// instead of duplicating this date-formatting logic.
export function getDateTime(value: string) {
  const dateTime = new Date(value || "");
  if (dateTime) {
    return (
      padLeadingZeros(dateTime.getDate(), 2) +
      "/" +
      padLeadingZeros(dateTime.getMonth() + 1, 2) +
      "/" +
      padLeadingZeros(dateTime.getFullYear(), 4) +
      " " +
      padLeadingZeros(dateTime.getHours(), 2) +
      ":" +
      padLeadingZeros(dateTime.getMinutes(), 2)
    );
  }
  return "";
}

export default function OrderSummarySection({ sale }: OrderSummarySectionProps) {
  return (
    <CardSection icon="receipt" title="Resumo">
      <UpdatedAt>{getDateTime(sale.updateStatus || "")}</UpdatedAt>
      {sale.reasonCancellation !== null && sale.reasonCancellation !== "" ? (
        <CancellationReason>{"Motivo: " + sale.reasonCancellation}</CancellationReason>
      ) : null}
      <SummaryRow
        label="Total dos itens"
        value={formatBRL((sale.total || 0) - (sale.tax || 0))}
      />
      <SummaryRow label="Taxa de Entrega" value={formatBRL(sale.tax)} />
      <SummaryRow label="Total do pedido" value={formatBRL(sale.total)} />
    </CardSection>
  );
}
